export default __webpack_public_path__ + "static/media/bl15.4fbb935d.png";